module.exports = __webpack_public_path__ + "images/emoji/question.83d2745c94b9b189e573.png";